import script from "./modelStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./modelStatus.vue?vue&type=script&setup=true&lang=js"

import "./modelStatus.vue?vue&type=style&index=0&id=6432e10e&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6432e10e"]])

export default __exports__